import dayjs from 'dayjs'

export function formatAppealDateTime(value) {
  if (value == null || value === '') return ''
  const parsed = dayjs(String(value).replace(/\//g, '-'))
  return parsed.isValid() ? parsed.format('YYYY/MM/DD HH:mm') : String(value)
}

export function formatTtVersionFromNumber(ttVersion) {
  const n = Number(ttVersion)
  if (ttVersion == null || ttVersion === '' || Number.isNaN(n) || n <= 0) {
    return '—'
  }
  return `V${n}`
}

function buildAppealFeedbackText(data) {
  const feedback = data.feedback || {}
  const reviewStatus = Number(
    data.reviewStatus != null
      ? data.reviewStatus
      : feedback.overall_review_status != null
        ? feedback.overall_review_status
        : feedback.review_status
  )
  if (reviewStatus === 6) {
    return 'TT 反馈申诉通过'
  }
  if (reviewStatus === 7) {
    return 'TT 反馈维持原驳回结果'
  }
  const messages = (feedback.client_key_result_list || [])
    .map((item) => (item.error_message || '').trim())
    .filter(Boolean)
  return messages.join('；')
}

function mapAppealAttachments(data) {
  const list = Array.isArray(data.attachments) ? data.attachments : []
  const mapped = list
    .map((item, index) => {
      const fileUrl = (item && item.fileUrl) || ''
      const name =
        (item && item.fileOriginalName && String(item.fileOriginalName).trim()) ||
        (item && item.fileName && String(item.fileName).trim()) ||
        ''
      if (!fileUrl) return null
      return {
        id: String((item && item.fileId) || index),
        name: name || '附件',
        fileUrl
      }
    })
    .filter(Boolean)
  if (mapped.length) return mapped

  const attachmentIds = Array.isArray(data.attachmentIds)
    ? data.attachmentIds
    : []
  return attachmentIds.map((id) => ({
    id: String(id),
    name: `附件 ${id}`,
    fileUrl: ''
  }))
}

/**
 * GET /review/{id}/appeal → 审核记录 / 申诉理由弹窗展示结构
 */
export function mapAppealDetailFromApi(data, options = {}) {
  if (!data) return null
  const attachments = mapAppealAttachments(data)
  const appealReason = (data.reason || '').trim()
  const submittedAt = formatAppealDateTime(data.appealedAt)
  const hasAppeal =
    !!appealReason || !!submittedAt || attachments.length > 0

  if (!hasAppeal) return null

  const reviewStatus = Number(data.reviewStatus)
  const feedbackText = buildAppealFeedbackText(data)
  const pendingFeedback = reviewStatus === 5 && !feedbackText

  return {
    hasAppeal: true,
    version: formatTtVersionFromNumber(data.ttVersion),
    ttVersion: data.ttVersion,
    appealReason: appealReason || '—',
    submittedAt: submittedAt || '—',
    attachments,
    pendingFeedback,
    feedbackAt: pendingFeedback
      ? ''
      : formatAppealDateTime(options.feedbackAt) || submittedAt,
    feedbackText
  }
}
